import { EmptyPoolStorageGenConstant } from "presentation/constant/EmptyPoolStorageGeneration/EmptyPoolStorageGenConstant";
import { useEmptyPoolStorageGenVM } from "presentation/hook/EmptyPoolStorageGeneration/useEmptyPoolStorageGenVM";
import { useEmptyPoolStorageGenTracked } from "presentation/store/EmptyPoolStorageGeneration/EmptyPoolStorageGenProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useMemo } from "react";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";

const EmptyPoolStorageGenSearchForm = () => {
    const EMP_POOL_STORAGE_GEN_CONSTANT = EmptyPoolStorageGenConstant.Charge;
    const [emptyPoolStorageGenerationState] = useEmptyPoolStorageGenTracked();
    const emptyPoolStorageGenSearchCriteria = emptyPoolStorageGenerationState.searchCriteria;
    const emptyPoolStorageGenVM = useEmptyPoolStorageGenVM();

    const memoChargeOnCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={emptyPoolStorageGenSearchCriteria?.chargeOnCompanies?.join(',')}
                fieldValue={emptyPoolStorageGenSearchCriteria?.chargeOnCompanies}
                fieldLabel={EMP_POOL_STORAGE_GEN_CONSTANT.CHARGE_ON_COMPANY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeOnCompanies'}
                maxLength={60}
                isMultipleDropDown={true}
                options={emptyPoolStorageGenerationState.dynamicOptions.chargeOnCompanyDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    emptyPoolStorageGenVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />

        </div>
        , [EMP_POOL_STORAGE_GEN_CONSTANT.CHARGE_ON_COMPANY, emptyPoolStorageGenSearchCriteria.chargeOnCompanies, emptyPoolStorageGenerationState.dynamicOptions.chargeOnCompanyDropdownOptions, emptyPoolStorageGenVM])

    const memoBillToCompany = useMemo(() =>
        <div className='im-flex-row-item'>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={emptyPoolStorageGenSearchCriteria?.billToCompanies?.join(',')}
                fieldValue={emptyPoolStorageGenSearchCriteria?.billToCompanies}
                fieldLabel={EMP_POOL_STORAGE_GEN_CONSTANT.BILL_TO_COMPANY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'billToCompanies'}
                maxLength={60}
                isMultipleDropDown={true}
                options={emptyPoolStorageGenerationState.dynamicOptions.billToCompanyDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    emptyPoolStorageGenVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [EMP_POOL_STORAGE_GEN_CONSTANT.BILL_TO_COMPANY, emptyPoolStorageGenSearchCriteria.billToCompanies, emptyPoolStorageGenerationState.dynamicOptions.billToCompanyDropdownOptions, emptyPoolStorageGenVM])

    const memoOpsDateFromTo = useMemo(() =>
        <div className='im-flex-row-item'>
            <DateRangePickerComponent
                label={EMP_POOL_STORAGE_GEN_CONSTANT.OPS_DATE_RANGE}
                width='330px'
                fieldNames={{ startField: "opsDateFrom", endField: "opsDateTo" }}
                dateRange={{ startDate: emptyPoolStorageGenSearchCriteria.opsDateFrom, endDate: emptyPoolStorageGenSearchCriteria.opsDateTo }}
                onDatesChange={emptyPoolStorageGenVM.onDateRangeChange}
            />
        </div>
        , [EMP_POOL_STORAGE_GEN_CONSTANT.OPS_DATE_RANGE, emptyPoolStorageGenSearchCriteria.opsDateFrom, emptyPoolStorageGenSearchCriteria.opsDateTo, emptyPoolStorageGenVM.onDateRangeChange])

    return <>

        <CriteriaItemContainer>
            {emptyPoolStorageGenerationState.enabledSearchCriteria.chargeOnCompanies ? memoChargeOnCompany : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {emptyPoolStorageGenerationState.enabledSearchCriteria.billToCompanies ? memoBillToCompany : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {emptyPoolStorageGenerationState.enabledSearchCriteria.opsDate ? memoOpsDateFromTo : null}
        </CriteriaItemContainer>

    </>;
}
export default memo(EmptyPoolStorageGenSearchForm);